module.exports = __webpack_public_path__ + "static/media/bruno.2488bded.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/bruno.png
// module id = 466
// module chunks = 0